import { render, staticRenderFns } from "./AddEditPotentialStudent.vue?vue&type=template&id=98f61b16&scoped=true"
import script from "./AddEditPotentialStudent.vue?vue&type=script&lang=js"
export * from "./AddEditPotentialStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f61b16",
  null
  
)

export default component.exports